var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdi-light:comment-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BP-My-BP-details",
    transform: "translate(-1024.000000, -153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:comment-text",
    transform: "translate(1024.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,3 L18,3 C19.6568542,3 21,4.34314575 21,6 L21,15 C21,16.6568542 19.6568542,18 18,18 L13.414,18 L9.707,21.707 C9.42100575,21.9929079 8.99096338,22.0784219 8.61734544,21.923678 C8.2437275,21.7689341 8.00008635,21.4043959 8,21 L8,18 L5,18 C3.34314575,18 2,16.6568542 2,15 L2,6 C2,4.34314575 3.34314575,3 5,3 Z M18,4 L5,4 C3.8954305,4 3,4.8954305 3,6 L3,15 C3,16.1045695 3.8954305,17 5,17 L9,17 L9,21 L13,17 L18,17 C19.1045695,17 20,16.1045695 20,15 L20,6 C20,4.8954305 19.1045695,4 18,4 Z M5,7 L18,7 L18,8 L5,8 L5,7 Z M5,10 L17,10 L17,11 L5,11 L5,10 Z M5,13 L13,13 L13,14 L5,14 L5,13 Z",
    id: "Icon-Shape"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Icon-Path",
    fill: "#0C1229",
    points: "20 23 20 21 18 21 18 20 20 20 20 18 21 18 21 20 23 20 23 21 21 21 21 23"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/addComment.c2473fd67ca1bbece095e38fa32f0440.svg";
export { ForwardRef as ReactComponent };